export const MAIN_ROUTE_NAME = Symbol('main');
export const ADMIN_ROUTE_NAME = Symbol('main.admin');
export const AFFILIATE_ROUTE_NAME = Symbol('affiliate');
export const ANONYMOUS_ROUTE_NAME = Symbol('anonymous');
export const SHARED_ROUTE_NAME = Symbol('shared');

export const ADMIN_REDIRECT_ROUTE_NAME = Symbol('admin.redirect');
export const AFFILIATE_REDIRECT_ROUTE_NAME = Symbol('affiliate.redirect');
